export interface Address {
    zipCode: string;
    line1: string;
    city: string;
    countryId: number;
}

export function addressToString(address: Address): string {
    const fullAddress = [];
    const linia2 = ((address.zipCode || '') + ' ' + (address.city || '')).trim();

    address.line1 && fullAddress.push(address.line1);
    linia2 && fullAddress.push(linia2);

    return fullAddress.join(', ');
}
